import { useEffect, useState } from 'react';
import ConfirmModal from '../../components/modal/confirm-modal';
import ToastNotification, { showToast } from '../../components/toasts/ToastNotification';
import './admin-employee.css';
import { HashLoader } from 'react-spinners';
import { deleteUserForAdmin, getEmployees } from '../../api/user.api';
import { hasPermission } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';
import { FaEye } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { useUser } from '../../context/UserContext';
import { MdOutlineAdd } from "react-icons/md";
import AddEmployeeModal from '../../components/modal/add-employee-modal';

export const AdminEmployee = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddEmployeeModalOpen, setIsAddEmployeeModalOpen] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedIdToDelete, setSelectedIdToDelete] = useState("");
    const navigate = useNavigate();
    const { user } = useUser();

    useEffect(() => {
        document.title = 'Admin - Nhân viên';
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const res = await getEmployees();

            if (res.success) {
                setEmployees(res.data.employees || []);
            }
        } catch (error) {
            showToast(error.message, "error");
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteUser = async (userId) => {
        setLoading(true);
        setIsModalOpen(false);
        try {
            const res = await deleteUserForAdmin(userId);
            if (res.success) {
                fetchEmployees();
                showToast("Xóa người dùng thành công", "success");
                setSelectedIdToDelete("");
            }
        } catch (error) {
            showToast(error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loader-container">
                <HashLoader color="#092339" />
            </div>
        );
    }

    return (
        <div className="admin-payment-container">
            <AddEmployeeModal
                title={'Thêm một nhân viên mới'}
                isOpen={isAddEmployeeModalOpen}
                onClose={() => setIsAddEmployeeModalOpen(false)}
                setEmployees={setEmployees}
            />
            <p className="tab-nav-title">Danh sách nhân viên</p>
            {hasPermission(user?.role, "create:employees") &&
                <div className="admin-product-header">
                    <a
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsAddEmployeeModalOpen(true)}
                        className="add-product-button-container"
                    >
                        <MdOutlineAdd className="add-icon" />
                        <p className="add-text">Thêm nhân viên mới</p>
                    </a>
                </div>}
            <div className="product-table-container">
                <table className="product-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>ID</th>
                            <th>Tên người dùng</th>
                            <th>Vai trò</th>
                            <th>Tạo lúc</th>
                            <th>Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employees.length > 0 ? (
                            employees.map((tx, index) => (
                                <tr key={tx?._id}>
                                    <td>{index + 1}</td>
                                    <td>{tx?._id}</td>
                                    <td>
                                        <a onClick={() => tx?._id !== user?._id && navigate(`/super-admin/users/view/${tx?._id}`)} className="table-product-name">{tx?.username}</a>
                                    </td>
                                    <td>
                                        <div className={`user-role-container ${tx?.role}`}>
                                            {tx?.role}
                                        </div>
                                    </td>
                                    <td>{new Date(tx?.createdAt).toLocaleString()}</td>
                                    <td className="action-cell">
                                        <div className="action-buttons-container">
                                            {tx?._id !== user?._id && (
                                                <>
                                                    <button
                                                        onClick={() => navigate(`/super-admin/users/view/${tx?._id}`)}
                                                        className="view-btn action-button"
                                                    >
                                                        <FaEye className="action-icon" />
                                                    </button>
                                                    {hasPermission(user?.role, "delete:user") &&
                                                        <button
                                                            onClick={() => {
                                                                setIsModalOpen(true);
                                                                setSelectedIdToDelete(tx?._id);
                                                            }}
                                                            className="delete-btn action-button"
                                                        >
                                                            <MdDelete className="action-icon" />
                                                        </button>}
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9">Không có người dùng</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <ToastNotification />
            <ConfirmModal
                isOpen={isModalOpen}
                onConfirm={() => handleDeleteUser(selectedIdToDelete)}
                onClose={() => setIsModalOpen(false)}
                message={"Hãy chắc chắn rằng bạn đang xóa một người dùng, điều này sẽ xóa tất cả những dữ liệu về người dùng này."}
                title={"Xóa người dùng"}
            />
        </div>
    );
}